const config = require('../temp/config');

const isDisconnected = /localhost/i.test(config.sitecoreApiHost);
module.exports = {
  isDisconnected,
};

// console.log(`[Utils/Utils] is disconnected:${isDisconnected}`);
